import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import { CONTIUNITY_PLAN_BILLING_ID } from '../../new-site-app/constants';
import pricing from './pricing';
import teamDetails from './team/details';
import teamInvitation from './team/invitation';
import teamInvoices from './team/invoices';
import teamManagement from './team/management';

export default {
  modules: {
    pricing,
    teamDetails,
    teamInvoices,
    teamInvitation,
    teamManagement,
  },

  getters: {
    isLoggedIn(state) {
      return !!state.user.id;
    },

    paidUser(state, getters) {
      if (getters.isLoggedIn && state.user.gateway === 'billing_engine' && state.user.paying_user) {
        return true;
      }

      return getters.isLoggedIn && (state.user.plan !== 'free' || state.user.has_team);
    },

    userType(state, getters) {
      if (!getters.isLoggedIn) {
        return 'visitor';
      }

      if (getters.paidUser) {
        return 'paid';
      }

      return 'free';
    },

    hasContinuityPlan(state, getters) {
      return getters.isLoggedIn && state.user.plan === CONTIUNITY_PLAN_BILLING_ID;
    },
    isLocalEnv() {
      return process.env.MIX_APP_ENV === 'local';
    },
    isDevelopmentEnv() {
      return process.env.MIX_APP_ENV === 'development';
    },
    isBetaEnv() {
      if (typeof window !== 'undefined') {
        return (
          location.hostname.includes('beta.motionarray.com') ||
          location.hostname.includes('beta2.motionarray.com')
        );
      }
      return false;
    },
    hasHolidayPromo(state, getters) {
      return typeof window !== 'undefined' && window.__MA__.plans.annual.discount?.stripe_coupon === 'HOLIDAYPROMOTION_23';
    },
  },

  state: {
    user: typeof window !== 'undefined' ? window.__MA__.user : context.__MA__.user,
    openTopNavDrawer: false,
    openSignInModal: false,
    openSignUpModal: false,
  },

  mutations: {
    SET_OPEN_TOP_NAV_DRAWER(state, payload) {
      state.openTopNavDrawer = payload;
    },
    SET_OPEN_SIGN_IN_MODAL(state, payload) {
      state.openSignInModal = payload;
    },
    SET_OPEN_SIGN_UP_MODAL(state, payload) {
      state.openSignUpModal = payload;
    },
  },

  actions: {
    setOpenTopNavDrawer({ commit }, payload) {
      if (payload) {
        commit('SET_OPEN_SIGN_IN_MODAL', false);
        commit('SET_OPEN_SIGN_UP_MODAL', false);
      }
      commit('SET_OPEN_TOP_NAV_DRAWER', payload);
    },
    setOpenSignInModal({ commit }, { open, clickSource, buttonName, assetId }) {
      if (open) {
        eventTracker(analyticsEvents.signInPopupOpened, {
          click_source: clickSource,
          button_name: buttonName,
          asset_id: assetId,
        });
        commit('SET_OPEN_TOP_NAV_DRAWER', false);
        commit('SET_OPEN_SIGN_UP_MODAL', false);
      }
      commit('SET_OPEN_SIGN_IN_MODAL', open);
    },
    setOpenSignUpModal({ commit }, { open, clickSource, buttonName, assetId }) {
      if (open) {
        eventTracker(analyticsEvents.signUpPopupOpened, {
          click_source: clickSource,
          button_name: buttonName,
          asset_id: assetId,
        });
        commit('SET_OPEN_TOP_NAV_DRAWER', false);
        commit('SET_OPEN_SIGN_IN_MODAL', false);
      }
      commit('SET_OPEN_SIGN_UP_MODAL', open);
    },
  },
};
